import { mediaMax } from "components/designV2/breakpoints";
import { Spacing } from "components/designV2/constants";
import styled from "styled-components";

export const RowCard = styled.div<{ $isInactive: boolean }>`
  width: 100%;
  opacity: ${(props) => (props.$isInactive ? 0.6 : 1)};
`;

export const RowGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(200px, 2fr) repeat(5, minmax(80px, 1fr)) auto;
  column-gap: 10px;
  align-items: center;
  width: 100%;

  ${mediaMax.desktop} {
    display: flex;
    flex-direction: column;
    gap: ${Spacing.sm}px;
  }
`;

export const RowTop = styled.div`
  display: contents;

  ${mediaMax.desktop} {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
`;

export const AvatarAndActions = styled.div`
  order: 100;
  display: flex;
  align-items: center;

  ${mediaMax.desktop} {
    order: unset;
  }
`;

export const RowMetrics = styled.div`
  display: contents;

  ${mediaMax.desktop} {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: ${Spacing.md}px ${Spacing.sm}px;
    width: 100%;
  }
`;
